exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".line--1Ag79 {\n\theight: 1px;\n\tbackground: #333;\n\twidth: 100%;\n\tmargin: 0;\n\tborder: none;\n\tdisplay: block;\n}\n", ""]);

// Exports
exports.locals = {
	"line": "line--1Ag79"
};